import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Login',
            component: () => import(/* webpackChunkName: "about" */ '../views/login/Index')
        },
        {
            path: '/logout',
            redirect: {
                name: "Login"
            }
        },
        {
            path: '/unauthorized',
            name: 'unauthorized',
            component: () => import(/* webpackChunkName: "about" */ '../views/info/Unauthorized')
        },
        {
            path: '/invalidPage',
            name: 'invalidPage',
            component: () => import(/* webpackChunkName: "about" */ '../views/info/InvalidSession')
        },
        {
            path: '/dashboard',
            component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/Index'),
            children: [
                {
                    name: 'Dashboard',
                    path: '',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/Dashboard'),
                    props: { userType: 'SME' }
                },
                {
                    name: 'UserList',
                    path: '/product/:userType',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/UserList'),
                    props: { userType1: 'RETAIL' }

                },
                // {
                //     name: 'SME',
                //     path: '/sme',
                //     component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/UserList'),
                //     props: { userType: 'SME' }
                // },
                {
                    name: 'ExportHistory',
                    path: '/export',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/ExportHistory')
                },
                {
                    name: 'Learning Resources',
                    path: '/learningResources',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/LearningResources')
                },
                {
                    name: 'Profile',
                    path: '/profile',
                    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/pages/Profile')
                }
            ]

        }
    ]
})
